"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Tooltip = exports.Tooltip = (0, _mui.styled)(({
  className,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
  ...props,
  classes: {
    popper: className
  }
}))({
  [`& .${_mui.tooltipClasses.tooltip}`]: {
    maxWidth: 180
  }
});